module.exports = __webpack_public_path__ + "static/media/3.1ef8fd21.jpg";